<template>
  <div class="tf-loader" role="status" aria-label="Loading">
    <svg class="tf-loader__ring" viewBox="0 0 80 80" aria-hidden="true">
      <defs>
        <linearGradient id="tf-loader-ring" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="#10d5ff" />
          <stop offset=".55" stop-color="#3f26e7" />
          <stop offset="1" stop-color="#ff00ff" />
        </linearGradient>
      </defs>
      <path :d="ringPath" />
    </svg>
    <svg class="tf-loader__logo" viewBox="41.53 169.66 137.6 137.6" aria-hidden="true">
      <defs>
        <linearGradient
          id="tf-loader-logo"
          x1="156.22" y1="192.57" x2="64.43" y2="284.36"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#10d5ff" />
          <stop offset=".58" stop-color="#3f26e7" />
          <stop offset="1" stop-color="#ff00ff" />
        </linearGradient>
      </defs>
      <path d="M133.32,307.25v-45.8h45.8l-45.8,45.8ZM133.32,169.67v45.8h45.8l-45.8-45.8ZM87.33,307.26v-45.8h-45.8l45.8,45.8ZM41.53,215.46h45.8v-45.8l-45.8,45.8Z" />
    </svg>
  </div>
</template>

<script>
const POINTS = 120;
const RADIUS = 34;
const AMPLITUDE = 2.6;
const RIPPLES = 12;

function wavyRing(phase) {
  const pts = [];
  for (let i = 0; i <= POINTS; i++) {
    const t = (i / POINTS) * Math.PI * 2;
    const r = RADIUS + AMPLITUDE * Math.sin(RIPPLES * t + phase);
    pts.push(`${(40 + r * Math.cos(t - Math.PI / 2)).toFixed(2)} ${(40 + r * Math.sin(t - Math.PI / 2)).toFixed(2)}`);
  }
  return `M${pts.join("L")}Z`;
}

export default {
  name: "Loader",
  data() {
    return { phase: 0, frame: null };
  },
  computed: {
    ringPath() {
      return wavyRing(this.phase);
    },
  },
  mounted() {
    const tick = () => {
      this.phase -= 0.12;
      this.frame = requestAnimationFrame(tick);
    };
    this.frame = requestAnimationFrame(tick);
  },
  beforeDestroy() {
    cancelAnimationFrame(this.frame);
  },
};
</script>

<style scoped>
.tf-loader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 8rem;
  height: 8rem;
  display: grid;
  place-items: center;
}
.tf-loader__ring {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  animation: tf-loader-turn 6s linear infinite;
}
.tf-loader__ring path {
  fill: none;
  stroke: url(#tf-loader-ring);
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.tf-loader__logo {
  width: 3.25rem;
  height: 3.25rem;
  animation: tf-loader-breathe 1.6s ease-in-out infinite;
}
.tf-loader__logo path {
  fill: url(#tf-loader-logo);
}
@keyframes tf-loader-breathe {
  0%, 100% {
    transform: scale(0.92);
    opacity: 0.75;
  }
  50% {
    transform: scale(1.08);
    opacity: 1;
  }
}
@keyframes tf-loader-turn {
  to {
    transform: rotate(360deg);
  }
}
</style>
